const BoardData = [
    {
      idx: 1,
      title: "게시판 리스트 비밀번호 테스트 입니다.",
      createuser: "관리자",
      createat: "2077-01-01",
      password: "123"
    },
    {
      idx: 2,
      title: "게시판 리스트 비밀번호 테스트 입니다.",
      createuser: "관리자",
      createat: "2067-02-02",
      password: "1234"
    },
    {
      idx: 3,
      title: "게시판 리스트 비밀번호 테스트 입니다.",
      createuser: "관리자",
      createat: "2057-03-03",
      password: "1234"
    },
    {
      idx: 4,
      title: "게시판 리스트 비밀번호 테스트 입니다.",
      createuser: "관리자",
      createat: "2047-04-04",
      password: "1234"
    },
    {
      idx: 5,
      title: "게시판 리스트 테스트입니다.",
      createuser: "관리자",
      createat: "2037-05-05",
      password : ""
    },
    
  ];

export default BoardData.reverse();